import React from 'react';
import StripeRegistrationButton from '../../../../Stripe/Component/StripeRegistrationButton/StripeRegistrationButton';
import Text from '../../../../../Components/Base/Text/Text';
import useStripe from '../../../../Stripe/Hooks/useStripe';
import styles from 'CaseTypeListStripeNotification.module.scss';

const CaseTypeListStripeNotification: React.FC = () => {
	const { isStripeSetupRequested } = useStripe();

	if (isStripeSetupRequested) {
		return (
			<div className={styles.wrapper}>
				<Text
					tx='component.caseTypeListStripeNotification.text'
					className={styles.text}
				/>
				<StripeRegistrationButton />
			</div>
		);
	}

	return <></>;
};

export default CaseTypeListStripeNotification;
